import { Component, OnInit } from '@angular/core';
import { HomeApiService } from '../../data/HomeApi.service';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit {
  constructor(
    private homeApi: HomeApiService,
    private auth: AuthService,
    private router: Router
  ) { };

  userProfile : any = {};
  listMenu: any = [];

  public disabled = false;
  public status: { isopen: boolean } = { isopen: false };

  public toggled(open: boolean): void {
    console.log('Dropdown is now: ', open);
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  ngOnInit(): void {
    this.homeApi.GetUserProfile()
      .subscribe(data => {
        this.userProfile = data;
      }, 
      error => {}, 
      () => {
        this.homeApi.GetMenuFromApi()
          .subscribe(data => {
            data.forEach(element => {
              this.listMenu.push(element);
            });
            this.listMenu = data
          }
        );
      }
    );
  }

  logOut(){
    localStorage.clear();
    this.router.navigate(['invalid_page']);
    var newWindow = window.open(location.href, '_self');
    newWindow.close();
  }
}



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/app/layouts/full-layout.component.ts